import { types, actions } from './requests'
export const CREATEMOLD_TYPES = {
    ...types('CREATEMOLD'),
}
export const CREATEMOLD_ACTIONS = {
    ...actions('CREATEMOLD'),
}